// where undefined === no limit to query length
export const MAX_SEARCH_QUERY_LENGTH = undefined;
export const GROUPS_ROLE_ID_FOUNDER = 1;
